const generateId = (id => () => String(++id))(0)

export default generateId
